import SVGApprove from "../SVGApprove";
import SVGCancel from "../SVGCancel";

import { ButtonLink } from "~/components/Button";
import HasPermission from "~/components/HasPermission";
import { ViewerPermissions } from "~/contexts/ViewerContext";

type Props = {
  showApproveButton: boolean;
  showCancelButton: boolean;
  onClickOpenApprove: () => void;
  onClickOpenCancel: () => void;
  disabled?: boolean;
};

export default function ApproveCancelButton({
  showApproveButton,
  showCancelButton,
  onClickOpenApprove,
  onClickOpenCancel,
  disabled = false,
}: Props) {
  return (
    <>
      {showApproveButton && (
        <HasPermission permission={ViewerPermissions["transactions.approve"]}>
          <ButtonLink
            title="Approve outgoing transfers"
            style={{ padding: "0 0.5rem" }}
            color="success"
            onClick={onClickOpenApprove}
            disabled={disabled}
          >
            <SVGApprove style={{ fontSize: "1.5rem" }} data-testid="approveButton" />
          </ButtonLink>
        </HasPermission>
      )}
      {showCancelButton && (
        <HasPermission permission={ViewerPermissions["transactions.cancel"]}>
          <ButtonLink
            title="Cancel outgoing transfers"
            style={{ padding: "0 0.5rem" }}
            color="success"
            onClick={onClickOpenCancel}
            disabled={disabled}
          >
            <SVGCancel style={{ fontSize: "1.5rem" }} data-testid="cancelButton" />
          </ButtonLink>
        </HasPermission>
      )}
    </>
  );
}
